/** View-only session memory. Never stores books, order inputs or hotkey focus. */
type Kind = 'spread' | 'total';
type Choice = { scope: string; kind: Kind; event: string; line: string };
const MAX_CHOICES = 512;
const choices = new Map<string, Choice>();
const key = (scope: string, kind: Kind, event: string) => JSON.stringify([scope, kind, event]);

export function rememberSpreadTotalLine(
  scope: string | null, kind: Kind, event: string, line: string,
): void {
  if (!scope) return;
  const id = key(scope, kind, event);
  choices.delete(id);
  choices.set(id, { scope, kind, event, line });
  while (choices.size > MAX_CHOICES) choices.delete(choices.keys().next().value!);
}

export function rememberedSpreadTotalLine(scope: string | null, kind: Kind, event: string): string | undefined {
  return scope ? choices.get(key(scope, kind, event))?.line : undefined;
}

export function readSpreadTotalLines(scope: string | null, kind: Kind): Map<string, string> {
  const result = new Map<string, string>();
  if (scope) for (const choice of choices.values()) {
    if (choice.scope === scope && choice.kind === kind) result.set(choice.event, choice.line);
  }
  return result;
}

export function resetSpreadTotalLineMemory(): void {
  choices.clear();
}
